<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex flex-col md:flex-row">
    <div>
      <drdp-title [title]="t('common.classroom')" [tutorialUrls]="[{url: 'https://www.youtube.com/watch?v=2hdYJr-b_bQ'}]"></drdp-title>
    </div>
    <div class="flex-1 md:mt-2 mb-2 md:mb-0">
      <div class="flex justify-end items-end">
        <drdp-btn (click)="openModal()" *drdpCheckPermission="Permission.CreateClassrooms"><i class="uil uil-plus"></i>
      {{ t('classroom.addNew') }}</drdp-btn>
    </div>
  </div>
</div>

@if (user.stateId == states.california) {
  <div class="font-bold text-red-600 p-6 pt-4 bg-white rounded-[20px] mb-4">
    <i class="uis uis-exclamation-triangle mr-2 text-2xl"></i>
    {{ t('classroom.californiaNotice') }}
  </div>
}

<drdp-container>
  <drdp-search [textInputPlaceholder]="t('classroom.searchPlaceholder')" [searchInput]="searchInput" (search)="searchTable($event)"
  (clear)="onClear()"></drdp-search>
  <div class="p-5 w-full">
    <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="tableColumns"
      (editActionItem)="openModal($event)" (deleteActionItem)="deleteModal($event)">
    </drdp-add-edit-table>
  </div>
</drdp-container>
</div>
<mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalData" [pageIndex]="pageIndex"
  (page)="paginateTable(false)" class="mb-12">
</mat-paginator>
</ng-container>
